/**
 * @file TitleBar/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Kristen Elliott [kristen.elliott@cbc.ca]
 */
import PropTypes from "prop-types";
import { Heading } from "../../../Heading/component";
/**
 * Card list title bar.
 *
 * @param {Object} props The component props
 * @returns {React.Component} The TitleBar component
 */
export function TitleBar({ title = null, url, customTitleBar, titleClasses }) {
    if (!customTitleBar && !title && !url) {
        return null;
    }

    let titleBarContent = null;

    const useSmallerLetterSpacing = checkCondensedText(title);
    const className = useSmallerLetterSpacing ? "titleBar-condensed" : "";

    if (customTitleBar) {
        titleBarContent = customTitleBar;
    } else {
        titleBarContent = (
            <Heading
                text={title}
                level="h2"
                levelClassName="h3"
                link={url}
                className={titleClasses}
            />
        );
    }

    return <div className={"titleBar " + className}>{titleBarContent}</div>;
}

function checkCondensedText(title) {
    return "cbc in your community" === title?.toLowerCase();
}

TitleBar.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    customTitleBar: PropTypes.object,
    titleClasses: PropTypes.string, //Additional class names added to the heading container
};

export default TitleBar;
